import styled from "styled-components"

export const StyledMainButton = styled.button`
    border: none;
    background-color: #d690a8;
    border-radius: 20px;
    cursor: pointer;
    text-decoration: none !important;
    color: black !important;

    &:hover,
    &:focus {
        background-color: #cb6e8f !important;
    }
`